<template>
  <div
    class="home-top"
    :style="barStyle"
    v-show="isShowTop"
    v-if="isiPhone"
  >

    <span>
      <img
        src="@/assets/icon/logo.png"
        alt=""
      >更多精彩视频，等你来哦</span>
    <span
      class="btn"
      @click="$openApp"
    >打开看看</span>

  </div>
</template>
<script>
import { isiPhone } from '@/assets/utils/utils';

export default {
  props: {
    position: String,
  },
  data() {
    return {
      isShowTop: true,
      isiPhone,
    };
  },
  computed: {
    barStyle() {
      if (this.position === 'bottom') {
        return 'bottom:0;background: #000000;position: fixed;';
      }
      return 'top:0;';
    },
  },
  methods: {
    setScroll() {
      const scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
      if (scrollTop > 60) {
        this.isShowTop = true;
      } else {
        this.isShowTop = false;
      }
    },
  },
  mounted() {
    if (this.position === 'bottom') {
      this.isShowTop = false;
      window.addEventListener('scroll', () => {
        this.setScroll();
      });
    }
  },
};
</script>
<style lang="less" scoped>
.home-top{
  position: absolute;
  height: 60px;
  background: rgba(0,0,0,0.5);
  left: 0;
  right: 0;
  font-size: 16px;
  color: #ffffff;
  line-height: 60px;
  text-align: center;
  z-index: 100003;
  img {
    width: 36px;
    margin-right: 8px;
  }
  .btn{
    background: linear-gradient(#95b7ff, #4f79ff);
    border-radius: 18px;
    padding: 5px 15px;
    margin-left: 25px;
  }
}
</style>
